import React from 'react';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export function AIAssistantIcon(props) {
  return <SmartToyIcon {...props} />;
}

export default AIAssistantIcon;
